<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        {{ isCreating ? "Nova Espécie" : "Alterar Espécie" }}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Nome da Espécie <span class="red text">*</span></label>
              <input class="uppercase" v-model="species.name" @blur="species.name = $toUpperCase($event)">
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>      
        <button v-if="isUpdating" class="ui basic red button" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button>
        <button class="ui blue button" :class="{ loading: saving, disabled: !species.name || removing }" @click="onConfirm()">
          <i class="checkmark icon"></i>
          {{ isCreating ? "Confirmar" : "Atualizar" }}
        </button>
      </div>
    </div>

    <can-not-remove-modal ref="canNotRemoveModal" />

    <yes-no-modal ref="confirmRemovalModal" :message="'Confirma exclusão da espécie ' + species.name + ' ?'" 
      :danger="true" @onYes="onConfirmRemoval()"/>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"  
  import SpeciesService from "@/services/species-service"

  export default {

    name: "SpeciesFormModal",

    mixins: [modalDialog],

    data() {
      return {
        species: {},
        service: new SpeciesService(),
      }
    },
    
    methods: {

      load(species) {

        this.species = {}

        if (species)
          this.species = this.$cloneObject(species)

        this.show()
      },

      async onConfirm() {

        if (this.saving)
          return

        this.saving = true
        
        try {

          if (this.isCreating) {
            await this.service.create(this.species)
          } else {            
            await this.service.update(this.species)            
          }

          this.emit("onSave", this.species)

          this.$msg.success(this.isCreating ? "Espécie criada com sucesso" : "Espécie alterada com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.saving = false
        }
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.species)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {

        if (this.removing)
          return

        this.removing = true

        try {

          await this.service.remove(this.species) 

          this.emit("onRemove", this.species)

          this.$msg.success("Espécie excluída com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.removing = false
        }
      },
    },
  }

</script>
